export var getQuoteGABusinessInsuranceApproximatelyBusinessList = function getQuoteGABusinessInsuranceApproximatelyBusinessList() {
  return [{
    value: '< 1 year',
    label: '< 1 year'
  }, {
    value: '1+ to 3',
    label: '1+ to 3 year'
  }, {
    value: '3+ to 5',
    label: '3+ to 5 year'
  }, {
    value: '5+',
    label: '5+ year'
  }];
};
export var getQuoteGABusinessInsuranceAverageYearsProfessionalExperienceList = function getQuoteGABusinessInsuranceAverageYearsProfessionalExperienceList() {
  return [{
    value: '0 to 3',
    label: '0 to 3 year'
  }, {
    value: '3+ to 5',
    label: '3+ to 5 year'
  }, {
    value: '5+',
    label: '5+ year'
  }];
};
export var getQuoteGABusinessInsuranceWrittenContractsWithClientsList = function getQuoteGABusinessInsuranceWrittenContractsWithClientsList() {
  return [{
    value: '0%',
    label: 'None'
  }, {
    value: 'Less 50%',
    label: '<50%'
  }, {
    value: 'Less 75%',
    label: '50-75%'
  }, {
    value: 'Less 100%',
    label: '>75%'
  }, {
    value: 'All',
    label: '100%'
  }];
};
export var getQuoteGABusinessInsuranceWorkConductedBySubcontractorsList = function getQuoteGABusinessInsuranceWorkConductedBySubcontractorsList() {
  return [{
    value: 'Less 25%',
    label: '<25%'
  }, {
    value: 'Less 50%',
    label: '25–50%'
  }, {
    value: '50%+',
    label: '>50%'
  }];
};
export var getQuoteGABusinessInsuranceWorkRequireCertifiedPercentageList = function getQuoteGABusinessInsuranceWorkRequireCertifiedPercentageList() {
  return [{
    value: '5%',
    label: '5%'
  }, {
    value: '10%',
    label: '10%'
  }, {
    value: '50%',
    label: '50%'
  }, {
    value: '100%',
    label: '100%'
  }];
};